import React from "react";
import { Button, Col, FormLabel, Row, Table } from "react-bootstrap";
import { AppContext } from "../AppContext.js";
import { PageListBean } from "../ds/client_ds.js";
import {
  MiscellaneousChargeReasonBean,
  MiscellaneousChargeReasonSearchCriteria,
  RestMiscellaneousChargeReasonListRequest,
  RestReadRequest,
} from "../ds/ds.js";
import { DeleteIcon, DropDwnDown, DropDwnUp } from "../gui_components/Icons.js";
import {
  AlertToolBox,
  InputCheckbox,
  InputTextbox,
  NumberFormatInputbox,
  ShowError,
} from "../gui_components/UIComponents.js";
import { isEmpty, isEmptyArray } from "../gui_components/Util.js";
import { GenericAttributeLookupHandler } from "../lookup/GenericAttributeLookupHandler.js";
import {
  BaseInquiryPageListToolBar,
  BaseInquiryToolBar,
  BaseToolBar,
} from "../modules/BaseModule.js";
import { SecurityAccessManager } from "../security/SecurityAccessManager.js";
import { MasterService } from "../services/MasterService.js";

class MiscellaneousChargeReasonListForm extends React.Component {
  constructor(props) {
    super(props);
    this.listFormCodeRef = React.createRef();
  }

  componentDidMount() {}
  componentDidUpdate() {
    this.setInputFocus();
  }
  setInputFocus() {
    if (this.listFormCodeRef.current != null) {
      this.listFormCodeRef.current.focus();
    }
  }
  enterKeyEventHandler = (e) => {
    this.props.enterKeyEventHandler(e);
  };
  deleteService = (e, val, rowData) => {
    if (e.detail === 1) this.props.deleteService(val, rowData);
  };
  onChange = (e) => {
    this.props.onChange(e);
  };
  opentypeforms = (e) => {
    if (e.detail === 1) this.props.opentypeforms();
  };

  editMiscellaneousChargeReason = (e, val, rowData) => {
    if (e.detail === 1) this.props.editMiscellaneousChargeReason(val, rowData);
  };
  handleSortingChange = (e, accessor) => {
    if (e.detail === 1) this.props.handleSortingChange(accessor);
  };

  render() {
    let miscellaneousChargeReason_list =
      this.props.miscellaneousChargeReason_list;
    let miscellaneousChargeReasonData =
      this.props.miscellaneousChargeReasonData;

    return (
      <div>
        <div>
          <Row>
            <Col sm="2">
              <FormLabel id="searchBarLabel">
                Miscellaneous Charge Reason
              </FormLabel>
            </Col>
            <Col sm="2">
              <InputTextbox
                ref={this.listFormCodeRef}
                type="text"
                name="code"
                onChange={this.onChange}
                value={miscellaneousChargeReasonData.code}
                style={{ "text-transform": "uppercase" }}
                enterKeyEventHandler={this.enterKeyEventHandler}
                isMandatory={true}
              ></InputTextbox>
            </Col>

            <Col sm="1">
              <Button
                id="fabric_Add_Button"
                className="text-center"
                onClick={(e) => this.opentypeforms(e)}
              >
                Go
              </Button>
            </Col>
          </Row>
        </div>
        <div className="div_default">
          <Table id="fabrics_tables_default">
            <thead>
              <tr>
                <th onClick={(e) => this.handleSortingChange(e, "code")}>
                  Code
                  {this.props.order === "desc" &&
                  this.props.sortField === "code" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
                <th onClick={(e) => this.handleSortingChange(e, "description")}>
                  Name
                  {this.props.order === "desc" &&
                  this.props.sortField === "description" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
                <th onClick={(e) => this.handleSortingChange(e, "companyCode")}>
                  CompanyCode
                  {this.props.order === "desc" &&
                  this.props.sortField === "companyCode" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
                <th onClick={(e) => this.handleSortingChange(e, "isActive")}>
                  Active
                  {this.props.order === "desc" &&
                  this.props.sortField === "isActive" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
                {/* <th>Remove</th> */}
              </tr>
            </thead>
            <tbody>
              {miscellaneousChargeReason_list.map((Info, index) => (
                <tr key={index}>
                  <td>
                    <Button
                      variant="secondry"
                      className="hyperLinkText"
                      onClick={(e) =>
                        this.editMiscellaneousChargeReason(e, Info.code, Info)
                      }
                    >
                      {Info.code}
                    </Button>
                  </td>
                  <td> {Info.description}</td>
                  <td>{Info.companyCode}</td>
                  <td>{Info.isActive}</td>
                  {/* <td className="text-right">
                    <Button
                      variant="secondry"
                      className="hyperLinkText"
                      onClick={(e) => this.deleteService(e, Info.code, Info)}
                    >
                      {<DeleteIcon />}
                    </Button>
                  </td> */}
                </tr>
              ))}
            </tbody>
          </Table>
          {miscellaneousChargeReason_list.length != 0 ? null : (
            <div className="no_Data">{"NO DATA"}</div>
          )}
        </div>
      </div>
    );
  }
}

class MiscellaneousChargeReasonEntryForm extends React.Component {
  constructor(props) {
    super(props);
    this.codeRef = React.createRef();
  }

  componentDidMount() {
    this.setInputFocus();
  }

  setInputFocus() {
    if (this.codeRef.current != null) {
      this.codeRef.current.focus();
    }
  }
  onChange = (e) => {
    this.props.onChange(e);
  };
  onCurrencyCodeChange = (e) => {
    this.props.onCurrencyCodeChange(e);
  };
  currencyCodeEnterKeyEvent = (e) => {
    this.props.currencyCodeEnterKeyEvent(e);
  };
  displayAutoCompleteCurrencyList = () => {
    this.props.displayAutoCompleteCurrencyList();
  };

  render() {
    let miscellaneousChargeReasonData =
      this.props.miscellaneousChargeReasonData;
    let isDisableFields = this.props.isDisableFields;
    return (
      <div>
        <Row>
          <Col sm="1">
            {" "}
            <FormLabel>Company Code</FormLabel>{" "}
          </Col>
          <Col sm="2">
            {" "}
            <InputTextbox
              name="companyCode"
              type="text"
              placeholder="Enter CompanyCode"
              onChange={this.onChange}
              value={miscellaneousChargeReasonData.companyCode}
              disabled={true}
            />{" "}
          </Col>
          <Col sm="1">
            {" "}
            <FormLabel>Code</FormLabel>{" "}
          </Col>
          <Col sm="2">
            {" "}
            <InputTextbox
              ref={this.codeRef}
              name="code"
              type="text"
              placeholder="Enter MiscellaneousChargeReasonCode"
              onChange={this.onChange}
              value={miscellaneousChargeReasonData.code}
              style={{ "text-transform": "uppercase" }}
              disabled={isDisableFields}
              isMandatory={true}
            />{" "}
          </Col>
          <Col sm="1">
            <FormLabel>Name</FormLabel>{" "}
          </Col>
          <Col sm="2">
            <InputTextbox
              name="description"
              type="text"
              placeholder="Enter Name"
              onChange={this.onChange}
              value={miscellaneousChargeReasonData.description}
              style={{ "text-transform": "capitalize" }}
              isMandatory={true}
            />
          </Col>
          <Col sm="1">
            <FormLabel>Currency</FormLabel>{" "}
          </Col>
          <Col sm="2">
            {" "}
            <InputTextbox
              onChange={this.onCurrencyCodeChange}
              name="currencyCode"
              value={miscellaneousChargeReasonData.currencyCode}
              lookupRequired={true}
              lookupHandler={this.props.currencyLookupHandler}
              enterKeyEventHandler={this.currencyCodeEnterKeyEvent}
              autoCompleteListData={
                this.props.currencyCodePageListForAutoCompleteList
              }
              enableAutoCompleteTextBox={true}
              displayAutoCompleteList={this.displayAutoCompleteCurrencyList}
              showAutoCompleteList={this.props.showAutoCompleteCurrencyCodeList}
              style={{ "text-transform": "uppercase" }}
              isMandatory={true}
            ></InputTextbox>
          </Col>
          <Col sm="1">
            <FormLabel>Amount</FormLabel>{" "}
          </Col>
          <Col sm="2">
            <NumberFormatInputbox
              name="miscellaneousChargesAmount"
              type="text"
              placeholder="Enter Amount"
              onChange={this.onChange}
              value={miscellaneousChargeReasonData.miscellaneousChargesAmount}
              style={{ "text-transform": "capitalize" }}
              isMandatory={true}
            />
          </Col>
          <Col sm="1">
            <FormLabel>Active</FormLabel>
          </Col>
          <Col sm="1">
            {" "}
            <InputCheckbox
              type="checkbox"
              name="isActive"
              onChange={this.onChange}
              checked={miscellaneousChargeReasonData.isActive}
            />
          </Col>
        </Row>
      </div>
    );
  }
}

class MiscellaneousChargeReasonList extends React.Component {
  static contextType = AppContext;
  constructor(props) {
    super(props);
    this.state = {
      miscellaneousChargeReason_list: [],
      response: {},
      pageTitle: "Miscellaneous Charge Reason",
      miscellaneousChargeReasonData: new MiscellaneousChargeReasonBean(),
      pageList: new PageListBean(),
      criteria: new MiscellaneousChargeReasonSearchCriteria(),
      currencies: new Array(),
      isShowSaveButton: false,
      isShowClearCriteriaButton: false,
      isShowClearErrorButton: false,
      isShowBackButton: false,
      error_list: [],
      totalCount: 0,
      isMiscellaneousChargeReasonListFormOpen: true,
      isMiscellaneousChargeReasonEntryFormOpen: false,
      isShowNodes: false,
      selectedNode: "headerView",
      alertMessage: [],
      alertType: "",
      isShowAlert: false,
      isShowExitButton: true,
      isPageListToolBar: true,
      isLoadFirstButton: true,
      isLoadLastButton: true,
      isLoadPreviousButton: true,
      isLoadNextButton: true,
      isDisableFields: false,
      showAutoCompleteCurrencyCodeList: true,
      currencyCodePageListForAutoCompleteList: new Array(),
      currencyLookupHandler: null,
      order: "asc",
      sortField: "",
    };
  }

  componentDidMount() {
    const { appData } = this.context;
    this.companyCode = appData.companyCode;
    const { cache } = appData;
    this.cache = cache;
    let miscellaneousChargeReasonData = new MiscellaneousChargeReasonBean();
    miscellaneousChargeReasonData.companyCode = this.companyCode;
    this.setState({
      miscellaneousChargeReasonData: miscellaneousChargeReasonData,
    });
    this.loadPage(1);
    this.cleardata();
    this.loadCacheDetails();
    this.initLookupHandlers();
  }

  initLookupHandlers = () => {
    let currencyLookupHandler = new GenericAttributeLookupHandler(
      this.state.currencies,
      "Currency"
    );
    this.setState({ currencyLookupHandler: currencyLookupHandler });
  };

  loadCacheDetails = () => {
    // let attribute_cache = JSON.parse(localStorage.getItem("attributeCache"));
    const attribute_cache = { ...this.cache };

    const currencies = new Array();
    if (!isEmptyArray(attribute_cache.currencies))
      currencies.push(...attribute_cache.currencies);
    this.state.currencies = currencies;
  };

  moduleCaption = "Miscellaneous Charge Reason";

  cleardata = () => {
    let miscellaneousChargeReasonData = new MiscellaneousChargeReasonBean();
    miscellaneousChargeReasonData.companyCode = this.companyCode;
    this.setState({
      miscellaneousChargeReasonData: miscellaneousChargeReasonData,
    });
  };
  saveMiscellaneousChargeReasonResponse = (response) => {
    this.handleresponse(response.data);
    this.loadPage(1);
    this.cleardata();
    this.closeMiscellaneousChargeReasonEntryForm();
  };

  saveMiscellaneousChargeReason = () => {
    let input = this.state.miscellaneousChargeReasonData;
    if (input.isFetched == true) {
      if (
        SecurityAccessManager.MiscellaneousChargeReasonMaintenanceEdit_IsAccessible()
      ) {
        MasterService.updateMiscellaneousChargeReason(
          input,
          this.saveMiscellaneousChargeReasonResponse,
          this.errorCallBack
        );
      } else {
        let errMsg = "Access Denied";
        let errList = [];
        errList.push(errMsg);

        this.setState({
          alertMessage: errList,
          alertType: "danger",
          isShowAlert: true,
        });
      }
    } else {
      if (
        SecurityAccessManager.MiscellaneousChargeReasonMaintenanceCreate_IsAccessible()
      ) {
        MasterService.createMiscellaneousChargeReason(
          input,
          this.saveMiscellaneousChargeReasonResponse,
          this.errorCallBack
        );
      } else {
        let errMsg = " Access Denied";
        let errList = [];
        errList.push(errMsg);

        this.setState({
          alertMessage: errList,
          alertType: "danger",
          isShowAlert: true,
        });
      }
    }
  };
  disable = () => {
    this.setState({
      isDisableFields: true,
    });
  };

  editMiscellaneousChargeReasonResponse = (response) => {
    if (response.data != null) {
      if (response.data.miscChargeReasonBean != null) {
        let miscellaneousChargeReasonData = response.data.miscChargeReasonBean;
        this.setState({
          miscellaneousChargeReasonData: miscellaneousChargeReasonData,
        });
        this.disable();
      }
      this.openMiscellaneousChargeReasonEntryForm();
    }
  };

  editMiscellaneousChargeReason = (code) => {
    let readrestInput = new RestReadRequest();
    readrestInput.companyCode = this.companyCode;
    readrestInput.code = code;
    if (
      SecurityAccessManager.MiscellaneousChargeReasonMaintenanceView_IsAccessible()
    ) {
      MasterService.readMiscellaneousChargeReason(
        readrestInput,
        this.editMiscellaneousChargeReasonResponse,
        this.errorCallBack
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);

      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };

  onChange = (e) => {
    let miscellaneousChargeReasonData =
      this.state.miscellaneousChargeReasonData;
    miscellaneousChargeReasonData[e.target.name] = e.target.value;
    this.setState({
      miscellaneousChargeReasonData: miscellaneousChargeReasonData,
    });
  };

  handleresponse = (response) => {
    if (response.errors != null) {
      let errMsg = "";
      let errList = [];
      response.errors.map(
        (err) => (
          (errMsg = errMsg + err.messageDescription),
          errList.push(err.messageDescription)
        )
      );
      this.setState({ error_list: errList });
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }

    if (response.infos != null) {
      let infoMsg = "";
      let successList = [];
      response.infos.map(
        (info) => (
          (infoMsg = infoMsg + info.messageDescription),
          successList.push(info.messageDescription)
        )
      );
      this.setState({
        alertMessage: successList,
        alertType: "success",
        isShowAlert: true,
      });
    }
  };

  save = () => {
    this.saveMiscellaneousChargeReason();
  };

  back = () => {
    this.clearError();
    this.cleardata();
    this.hideAlertCallBack(false);
    this.closeMiscellaneousChargeReasonEntryForm();
  };
  clearError = () => {
    this.setState({ error_list: [] });
  };

  openMiscellaneousChargeReasonEntryForm = () => {
    this.setState({
      isMiscellaneousChargeReasonListFormOpen: false,
      isMiscellaneousChargeReasonEntryFormOpen: true,
      isShowSaveButton: true,
      isShowClearCriteriaButton: false,
      isShowClearErrorButton: true,
      isShowBackButton: true,
      isShowNodes: false,
      isPageListToolBar: false,
      isLoadFirstButton: false,
      isLoadLastButton: false,
      isLoadPreviousButton: false,
      isLoadNextButton: false,
    });
  };

  closeMiscellaneousChargeReasonEntryForm = () => {
    this.clearError();
    let pageTitle = this.moduleCaption;
    this.setState({
      isMiscellaneousChargeReasonListFormOpen: true,
      isMiscellaneousChargeReasonEntryFormOpen: false,
      isShowSaveButton: false,
      isShowClearCriteriaButton: false,
      isShowBackButton: false,
      isShowClearErrorButton: false,
      pageTitle: pageTitle,
      isShowNodes: false,
      isPageListToolBar: true,
      isLoadFirstButton: true,
      isLoadLastButton: true,
      isLoadPreviousButton: true,
      isLoadNextButton: true,
      isDisableFields: false,
    });
  };

  moduleExit = () => {
    this.props.onModuleExit();
  };

  loadMiscellaneousChargeReasonResponse = (response) => {
    if (
      response.data != null &&
      response.data.miscChargeReasonPageListBean != null
    ) {
      let miscChargeReasonBean = new Array();
      if (
        !isEmptyArray(
          response.data.miscChargeReasonPageListBean.miscChargeReasonBean
        )
      ) {
        miscChargeReasonBean =
          response.data.miscChargeReasonPageListBean.miscChargeReasonBean;
        miscChargeReasonBean.map((Info) => {
          if (Info.isActive == true) {
            Info.isActive = "True";
          } else {
            Info.isActive = "False";
          }
        });
      }
      let pageList = this.state.pageList;
      pageList.totalCount =
        response.data.miscChargeReasonPageListBean.totalCount;
      pageList.currentPage =
        response.data.miscChargeReasonPageListBean.currentPage;
      pageList.pageSize = response.data.miscChargeReasonPageListBean.pageSize;
      this.setState({
        miscellaneousChargeReason_list: miscChargeReasonBean,
        pageList: pageList,
      });
    }
  };
  loadFirst = () => {
    this.loadPage(1);
  };
  loadPrevious = () => {
    let currentPage = this.state.pageList.currentPage;
    let previousPage = currentPage - 1;
    this.loadPage(previousPage);
  };
  loadNext = () => {
    let currentPage = this.state.pageList.currentPage;
    let nextPage = currentPage + 1;
    this.loadPage(nextPage);
  };

  loadLast = () => {
    let pageSize = this.state.pageList.pageSize;
    let totalCount = this.state.pageList.totalCount;
    let totalPages = totalCount / pageSize;
    totalPages += totalCount % pageSize == 0 ? 0 : 1;
    this.loadPage(totalPages);
  };

  loadPage = (pageNumber) => {
    let criteria = new MiscellaneousChargeReasonSearchCriteria();
    criteria.companyCode = this.companyCode;
    let pageList = this.state.pageList;
    let pageInput = new PageListBean();
    pageInput.pageSize = 50;
    pageInput.currentPage = pageNumber;
    if (pageList != null) pageInput.totalCount = pageList.totalCount;
    this.state.pageList = pageInput;
    this.loadMiscellaneousChargeReasonPage(pageInput, criteria);
  };
  loadMiscellaneousChargeReasonPage = (pageList, searchCriteria) => {
    let requestInput = new RestMiscellaneousChargeReasonListRequest();
    requestInput.pageInput = pageList;
    requestInput.searchCriteria = searchCriteria;
    this.state.pageList = pageList;
    if (
      SecurityAccessManager.MiscellaneousChargeReasonMaintenanceView_IsAccessible()
    ) {
      MasterService.getMiscellaneousChargeReasonPageList(
        requestInput,
        this.loadMiscellaneousChargeReasonResponse,
        this.errorCallBack
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);

      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };

  onCurrencyCodeChange = (e) => {
    let currencyCode = e.target.value;
    this.state.showAutoCompleteCurrencyCodeList = true;
    let tempdata = this.state.miscellaneousChargeReasonData;
    let showAutoCompleteList = this.state.showAutoCompleteCurrencyCodeList;
    if (isEmpty(currencyCode)) {
      this.state.showAutoCompleteCurrencyCodeList = false;
      let showAutoCompleteList = this.state.showAutoCompleteCurrencyCodeList;
      let soLine = this.state.miscellaneousChargeReasonData;
      soLine.currencyCode = "";
      let suggestion = [];

      this.setState({
        showAutoCompleteList: showAutoCompleteList,
        miscellaneousChargeReasonData: soLine,
        currencyCodePageListForAutoCompleteList: suggestion,
      });
    } else if (showAutoCompleteList === true && currencyCode !== "") {
      this.readCurrencyCodeBySearchString(currencyCode);
    }
    if (e.target.name == "currencyCode") {
      tempdata["currencyCode"] = e.target.value;
      let currencyCode_List = this.state.currencies;
      currencyCode_List.map((pdtType) => {
        if (pdtType.code == e.target.value) {
          tempdata["currencyCode"] = pdtType.code;
          this.state.showAutoCompleteCurrencyCodeList = false;
          let showAutoCompleteList =
            this.state.showAutoCompleteCurrencyCodeList;
          this.setState({ showAutoCompleteList: showAutoCompleteList });
        }
      });
    }
    this.setState({ miscellaneousChargeReasonData: tempdata });
  };
  readCurrencyCodeBySearchString(searchString) {
    let currencyCodeData = this.state.currencies;
    let simpleAutoCompleteList = new Array();
    if (currencyCodeData.length > 0 && currencyCodeData != null) {
      currencyCodeData.map((currencyCodeDatas) => {
        let simpleItemBean = {
          code: currencyCodeDatas.code,
          description: currencyCodeDatas.description,
        };
        simpleAutoCompleteList.push(simpleItemBean);
      });
    }
    let userInput = searchString;

    let filteredSuggestions = new Array();

    filteredSuggestions = simpleAutoCompleteList.filter(
      (simpleAutoCompletecurrencyCodeLists) =>
        simpleAutoCompletecurrencyCodeLists.code
          .toLowerCase()
          .indexOf(userInput.toLowerCase()) > -1
    );
    this.setState({
      currencyCodePageListForAutoCompleteList: filteredSuggestions,
    });
  }
  currencyCodeEnterKeyEvent = (e) => {
    let tempdata = this.state.miscellaneousChargeReasonData;
    tempdata["currencyCode"] = e.target.value;
    let CurrencyCode_List = this.state.currencies;
    let CurrencyCodeBean = null;
    CurrencyCode_List.map((pdtType) => {
      if (pdtType.code == e.target.value) {
        CurrencyCodeBean = pdtType;
      }
    });
    if (!isEmpty(CurrencyCodeBean)) {
      let tempdata = this.state.miscellaneousChargeReasonData;
      tempdata.currencyCode = CurrencyCodeBean.code;
      this.setState({
        miscellaneousChargeReasonData: tempdata,
        currencyCodePageListForAutoCompleteList: new Array(),
      });
    }
  };
  displayAutoCompleteCurrencyList = (showAutoCompleteList) => {
    this.setState({ showAutoCompleteCurrencyCodeList: showAutoCompleteList });
  };

  enterKeyEventHandler = (e) => {
    e.preventDefault();
    setTimeout(() => {
      this.opentypeforms();
    }, 200);
  };
  opentypeforms = () => {
    let miscellaneousChargeReasonData =
      this.state.miscellaneousChargeReasonData;
    this.editMiscellaneousChargeReason(miscellaneousChargeReasonData.code);
  };
  deleteService = (code) => {
    let criteria = new MiscellaneousChargeReasonSearchCriteria();
    criteria.companyCode = this.companyCode;
    criteria.code = code;
    if (
      SecurityAccessManager.MiscellaneousChargeReasonMaintenanceDelete_IsAccessible()
    ) {
      MasterService.deleteMiscellaneousChargeReason(
        criteria,
        this.deleteMiscellaneousChargeReasonResponse,
        this.errorCallBack
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  deleteMiscellaneousChargeReasonResponse = (response) => {
    this.handleresponse(response.data);
    this.loadPage(1);
  };

  hideAlertCallBack = (msgType, isDisplayed) => {
    this.setState({ isShowAlert: isDisplayed, error_list: [] });
  };
  errorCallBack = (error) => {
    ShowError("Error : " + error);
  };

  handleSortingChange = (accessor) => {
    let sortField = accessor;
    let order = this.state.order;
    let sortOrder = accessor === sortField && order === "asc" ? "desc" : "asc";
    this.setState({
      order: sortOrder,
      sortField: sortField,
    });
    this.handleSorting(sortField, sortOrder);
  };
  handleSorting = (sortField, sortOrder) => {
    let list = this.state.miscellaneousChargeReason_list;
    if (sortField && !isEmptyArray(list)) {
      const sorted = [...list].sort((a, b) => {
        if (a[sortField] === null) return 1;
        if (b[sortField] === null) return -1;
        if (a[sortField] === null && b[sortField] === null) return 0;
        return (
          a[sortField].toString().localeCompare(b[sortField].toString(), "en", {
            numeric: true,
          }) * (sortOrder === "asc" ? 1 : -1)
        );
      });
      this.setState({ miscellaneousChargeReason_list: sorted });
    }
  };
  render() {
    let pageList = this.state.pageList;
    let totalPages = 0;
    let pageSize = this.state.pageList.pageSize;
    let totalCount = this.state.pageList.totalCount;
    totalPages = totalCount / pageSize;
    totalPages += totalCount % pageSize == 0 ? 0 : 1;
    let currentPage = pageList.currentPage;

    return (
      <div>
        <AlertToolBox
          alertMsgList={this.state.alertMessage}
          alertErrorType={this.state.alertType}
          isShowAlert={this.state.isShowAlert}
          hideAlertCallBack={this.hideAlertCallBack}
        />
        {this.state.isPageListToolBar && (
          <BaseInquiryPageListToolBar
            currentPage={currentPage}
            totalPages={totalPages}
            isLoadFirstButton={this.state.isLoadFirstButton}
            isLoadLastButton={this.state.isLoadLastButton}
            isLoadPreviousButton={this.state.isLoadPreviousButton}
            isLoadNextButton={this.state.isLoadNextButton}
            loadFirst={this.loadFirst}
            loadLast={this.loadLast}
            loadNext={this.loadNext}
            loadPrevious={this.loadPrevious}
          />
        )}
        {this.state.isMiscellaneousChargeReasonListFormOpen && (
          <BaseInquiryToolBar
            onModuleExit={() => this.moduleExit()}
            pageTitle={this.state.pageTitle}
            isShowExitButton={this.state.isShowExitButton}
          />
        )}

        {!this.state.isMiscellaneousChargeReasonListFormOpen && (
          <BaseToolBar
            back={this.back}
            save={this.save}
            clearError={this.clearError}
            isShowSaveButton={this.state.isShowSaveButton}
            isShowClearCriteriaButton={this.state.isShowClearCriteriaButton}
            isShowClearErrorButton={this.state.isShowClearErrorButton}
            isShowBackButton={this.state.isShowBackButton}
            pageTitle={this.state.pageTitle}
          />
        )}

        {this.state.isMiscellaneousChargeReasonListFormOpen && (
          <MiscellaneousChargeReasonListForm
            {...this.state}
            editMiscellaneousChargeReason={this.editMiscellaneousChargeReason}
            deleteService={this.deleteService}
            enterKeyEventHandler={this.enterKeyEventHandler}
            opentypeforms={this.opentypeforms}
            onChange={this.onChange}
            handleSortingChange={this.handleSortingChange}
          />
        )}

        {this.state.isMiscellaneousChargeReasonEntryFormOpen && (
          <MiscellaneousChargeReasonEntryForm
            {...this.state}
            onChange={this.onChange}
            onCurrencyCodeChange={this.onCurrencyCodeChange}
            currencyCodeEnterKeyEvent={this.currencyCodeEnterKeyEvent}
            displayAutoCompleteCurrencyList={
              this.displayAutoCompleteCurrencyList
            }
          />
        )}
      </div>
    );
  }
}

function MiscellaneousChargeReasonAttributeModule(props) {
  return (
    <div id="moduleContainer" className="module_container">
      <div className="app">
        <MiscellaneousChargeReasonList {...props} name="" />
        <br />
      </div>
    </div>
  );
}
export default MiscellaneousChargeReasonAttributeModule;
